module.exports = __webpack_public_path__ + "media/images/profile-grid2-857df826cb8250d00a65a3d4adefba9d.jpg";